'use client'

import { useEffect, useRef, useState, useCallback } from 'react'
import { useGetAllProductsMutation } from '@/shared/api-rtk/index.js'
import CatalogItems from '@/entities/catalog-page/CatalogItems/index.js'
import Pagination from '@/entities/catalog-page/Pagination/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { ClientCatalogPage } from './ClientCatalogPage'
import LoaderPage from '@/shared/ui/LoaderPage'

export const CatalogPage = ({ categoryId, catalogData, children }) => {
    const [data, setData] = useState(Object.values(catalogData.products))
    const [getALl, { isLoading }] = useGetAllProductsMutation()
    const [pageQuantity, setPageQuantity] = useState(1)
    const [loadMoreCounter, setLoadMoreCounter] = useState(1)
    const itemsRef = useRef(null)
    const [mount, setMount] = useState(false)

    const [configRequest, setConfigRequest] = useState({
        namePage: 'Вся продукция',
        category_id: categoryId,
        filters: [],
        current_page: 1,
        categories: [],
    })

    const scrollToHeader = () => {
        itemsRef.current.scrollIntoView()
    }

    const fetchProducts = useCallback(async () => {
        try {
            const res = await getALl(configRequest).unwrap()
            if (res.result === 'success') {
                const products = Object.values(res.data)
                setData(products)
                setPageQuantity(products[0]?.pages || 1)
            } else {
                // API вернул ошибку — показываем пустой список
                setData([])
                TOAST_ERROR(res.error || 'Ошибка загрузки данных')
            }
        } catch (error) {
            console.error('Ошибка загрузки:', error)
            setData([])
            TOAST_ERROR('По данным фильтрам товары не найдены :(')
        }
    }, [configRequest, getALl])

    useEffect(() => {
        setConfigRequest((prev) => ({
            ...prev,
            category_id: categoryId,
            current_page: 1,
        }))
        setLoadMoreCounter(1)
    }, [categoryId])

    useEffect(() => {
        fetchProducts()
    }, [configRequest, fetchProducts])

    return (
        <div className={'CatalogPage'}>
            <LoaderPage loading={isLoading || !mount} />
            <ClientCatalogPage
                setMount={setMount}
                categoryId={categoryId}
                configRequest={configRequest}
                setConfigRequest={setConfigRequest}
            />

            <div className={'catalog-items'} ref={itemsRef}>
                <CatalogItems
                    productsInCart={catalogData.productsInCart}
                    items={data}
                    configRequest={configRequest}
                    setMount={setMount}
                />

                <Pagination
                    setConfigRequest={(val) => setConfigRequest(val)}
                    currentConfig={configRequest}
                    products={data ?? catalogData.products}
                    setProducts={(val) => setData(val)}
                    pageQuantity={pageQuantity}
                    scrollToRef={scrollToHeader}
                    isLoading={isLoading}
                    loadMoreCounter={loadMoreCounter}
                    changeLoadMoreCounter={(val) => setLoadMoreCounter(val)}
                />
            </div>
        </div>
    )
}
